import { render, staticRenderFns } from "./quotehistory.component.vue?vue&type=template&id=c0e65d2e&"
import script from "./quotehistory.component.vue?vue&type=script&lang=tsx&"
export * from "./quotehistory.component.vue?vue&type=script&lang=tsx&"
import style0 from "./quotehistory.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports